// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"231":"5dcbb1e0","850":"620ad0de","937":"2e41a32d"}[chunkId] + ".css";
};